import axios from 'axios';

import {
  ChangeAliasRequest,
  ProfileDetails,
  ScopusIdChangeRequest,
  UpdateProfileRequest,
  WosResearcherIdRequest,
} from '@/module/Dashboard/model/DashboardTypes';

import { getData } from '@feature/utils';

export function getProfileDetails() {
  return axios.get<ProfileDetails>('/current-author/profile').then(getData);
}

export function syncWosPublications() {
  return axios.post<unknown>('/wos/sync/publications').then(getData);
}

export function addResearcherId(request: WosResearcherIdRequest) {
  return axios.put<unknown>(`/current-author/profile/researcher-id/add`, request);
}

export function deleteResearcherId(request: WosResearcherIdRequest) {
  return axios.put<unknown>(`/current-author/profile/researcher-id/remove`, request);
}

export function changeScopusId(request: ScopusIdChangeRequest) {
  return axios.put<unknown>(`/current-author/profile/change-scopus-id`, request);
}

export function addAlias(request: ChangeAliasRequest) {
  return axios.put<unknown>(`/current-author/profile/alias/add`, request);
}

export function updateProfile(request: UpdateProfileRequest) {
  return axios.put<unknown>(`/current-author/profile/update`, request);
}

export function removeAlias(request: ChangeAliasRequest) {
  return axios.put<unknown>(`/current-author/profile/alias/remove`, request);
}
